import React, { useEffect } from "react";
import { Button, Toast } from "..";
import { apis, asyncPost } from "Utils/axios";
import { formatedPrice } from "Utils/utils";

function PeachPayments({ onClose = () => {}, order }) {
	console.log("PeachPG");

	const scriptUrl = "https://sandbox-checkout.peachpayments.com/js/checkout.js";
	const loadScript = (src) => {
		return new Promise((resolve) => {
			const script = document.createElement("script");
			script.src = src;
			script.onload = () => resolve(true);
			script.onerror = () => resolve(false);
			document.body.appendChild(script);
			setTimeout(() => {
				if (order) startPayment(order);
			}, 1000);
		});
	};

	useEffect(() => {
		loadScript(scriptUrl);
	}, []);

	const startPayment = ({ entityId, checkoutId, amount, user, orderId }) => {
		console.log(entityId, checkoutId, amount, user);
		try {
			const checkout = window.Checkout.initiate({
				key: entityId,
				checkoutId,
				events: {
					onCompleted: async (event) => {
						console.log("onCompleted", event, orderId);
						const dismiss = Toast.loading("Adding money to wallet...");
						try {
							const { signature, checkoutId, currency } = event;
							asyncPost(apis.updatePaymentDetails, {
								signature,
								currency,
								checkoutId,
								orderId,
							}).then((res) => {
								Toast.success("Payment Received, your balance will reflect shortly");
								dismiss();
								setTimeout(() => {
									onClose();
									window.location.reload();
								}, 4000);
							});
						} catch (error) {
							console.error(error);
						}
					},
					onCancelled: () => {
						onClose();
					},
					onExpired: () => {
						onClose();
						Toast.error("Payment expired, please try again");
					},
				},
				options: { theme: { brand: { primary: "#be3735" }, cards: { background: "#ffffff" } }, enableCancelButton: true },
			});
			checkout.render("#payment-form");
		} catch (error) {
			console.error("Error: ", error);
		}
	};

	return (
		<div className="w-full">
			<div className="flex justify-between items-center p-2">
				<Button variant="outlined" onClick={onClose}>
					Close
				</Button>
				<p className="p-1 px-2 text-xs rounded-md border border-infoText bg-info text-infoText">
					Surcharge of ZAR {formatedPrice(order.surchargeAmount)} ({order.pgSurcharge}%) added
				</p>
			</div>
			<div className="overflow-hidden w-full rounded-b-3xl">
				<div id="payment-form" className="h-full min-h-[32rem] grid grid-cols-1"></div>
			</div>
		</div>
	);
}

export default PeachPayments;
